import { useEffect, useState, useCallback } from "react";
import { Facet as FacetType } from "@coveo/headless";
import {
	CoveoHeadlessFacetName,
	PageType
} from "components/coveo-headless/types/coveo-headless-types";
import { ImageArrow } from "components/utility/images";

type FacetGroupProps = {
	classes: {
		container: string;
		facetParent: string;
	};
	facets: FacetType[];
	fields: CoveoHeadlessFacetName[];
	page: string;
	toggle: boolean;
	setSelectedFacet: (facet: number) => void;
	setToggle: (toggle: boolean) => void;
};

const FacetGroup = ({
	classes,
	facets,
	fields,
	page,
	toggle,
	setSelectedFacet,
	setToggle
}: FacetGroupProps) => {
	const [facetName, setFacetName] = useState<string | null>(null);
	const [selectedDropdown, setSelectedDropdown] = useState<number>(-1);

	const setDropdownDefault = useCallback(() => {
		if (toggle) {
			setToggle(false);
		}
		setSelectedFacet(0);
		setFacetName(null);
		setSelectedDropdown(-1);
	}, [toggle, setToggle, setSelectedFacet, setFacetName, setSelectedDropdown]);

	useEffect(() => {
		window.addEventListener("scroll", setDropdownDefault);
		return () => {
			window.removeEventListener("scroll", setDropdownDefault);
		};
	}, [setDropdownDefault]);

	const handleClick = (name: string, index: number) => {
		if (facetName === null) {
			setFacetName(name);
			setToggle(true);
		} else if (facetName === name) {
			setFacetName(null);
			setToggle(false);
		} else if (facetName !== name) {
			setFacetName(name);
			setToggle(true);
		}

		setSelectedFacet(index);

		if (selectedDropdown === index) {
			return setSelectedDropdown(-1);
		}
		setSelectedDropdown(index);
	};

	return (
		<div className={classes.container}>
			{facets
				? facets.map((_facet, index) => (
						<div
							key={fields[index].facetField}
							aria-label={fields[index].facetField}
							aria-expanded={index === selectedDropdown}
							className={`${classes.facetParent} ${
								index === selectedDropdown && toggle ? "selected" : ""
							}`}
							data-order="0"
							data-tag={fields[index].facetField}
							data-qa={fields[index].facetField}
							data-a-evt="Subcontent View"
							data-a-comp="Browse Filter"
							data-a-text={fields[index].name}
							role="button"
							tabIndex={0}
							onClick={() => handleClick(fields[index].facetField, index)}
							onKeyDown={() => handleClick(fields[index].facetField, index)}
						>
							{page === PageType.Insights ? (
								fields[index].name
							) : page === PageType.MyDimensional ? (
								<h2 className={`t-heading-lg-italic tc-cool-gray-02 ${classes.facetParent}-name`}>
									{fields[index].name}
									<ImageArrow />
								</h2>
							) : (
								fields[index].name
							)}
						</div>
					))
				: null}
		</div>
	);
};

export default FacetGroup;
